import { render, staticRenderFns } from "./BrowseCatalogueServices.vue?vue&type=template&id=00610f40&scoped=true"
import script from "./BrowseCatalogueServices.vue?vue&type=script&lang=js"
export * from "./BrowseCatalogueServices.vue?vue&type=script&lang=js"
import style0 from "./BrowseCatalogueServices.vue?vue&type=style&index=0&id=00610f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00610f40",
  null
  
)

export default component.exports